<template>
  <div class="drawer-wrapper" v-loading.fullscreen.lock="loading">
    <el-drawer :wrapperClosable="true" :title="title" :visible.sync="dialogVisible" size="60%"
               :before-close="handleClose" direction="rtl">
      <div class="demo-drawer__content">
        <el-form :model="addFrom" :rules="rules" ref="ruleForm">
          <el-row :gutter="35">
            <el-col :span="24" class="mb20">
              <el-form-item label="标题" prop="title" :label-width="formLabelWidth">
                <el-input v-model="addFrom.title" placeholder="请输入标题" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" class="mb20">
              <el-form-item label="名字" prop="author_name" :label-width="formLabelWidth">
                <el-input v-model="addFrom.author_name" placeholder="请输入名字" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" class="mb20">
              <el-form-item label="时间" prop="publish_time" :label-width="formLabelWidth">
                <el-date-picker v-model="addFrom.publish_time" type="datetime" placeholder="请选择时间"
                                value-format="yyyy-MM-dd HH:mm:ss" style="width: 90%;"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="24" class="mb20">
              <el-form-item label="封面" :label-width="formLabelWidth">
                <ImageUpload v-model="addFrom.cover" :size="160" />
              </el-form-item>
            </el-col>
            <el-col :span="24" class="mb20">
              <el-form-item label="排序" prop="listorder" :label-width="formLabelWidth">
                <el-input-number v-model="addFrom.listorder" :min="0" controls-position="right"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="24" class="mb20">
              <el-form-item label="内容" :label-width="formLabelWidth">
                <RichEditor v-model="addFrom.content" placeholder="请输入政策资讯内容" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="AddNone">取 消</el-button>
        <el-button type="primary" @click="addPush">确 定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { rcApis } from "@/api/rc";
import { processErrors } from "@/utils/errorHandler";
import ImageUpload from "@/components/ImageUpload";
import RichEditor from "@/components/RichEditor";
const api = rcApis();
export default {
  props: ['dialogVisible', "editID"],
  components: { ImageUpload, RichEditor },
  data() {
    return {
      title: "新增",
      formLabelWidth: "100px",
      addFrom: { title: "", author_name: "", publish_time: "", cover: "", content: "", listorder: 0 },
      loading: false,
      isask: false,
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
      },
    };
  },
  mounted() {
    if (this.editID != "") {
      this.loading = true;
      api.PolicyInfo({ id: this.editID }).then(res => {
        this.loading = false;
        if (res.code == 0) {
          this.title = "编辑";
          this.addFrom = res.data;
        } else {
          processErrors(res);
        }
      });
    }
  },
  methods: {
    handleClose() {
      this.$emit('NoneDlog');
      this.$refs['ruleForm'].resetFields();
    },
    AddNone() {
      this.$refs['ruleForm'].resetFields();
      this.$emit('NoneDlog');
    },
    addPush() {
      if (this.isask) return;
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.isask = true;
          let createText = this.editID == "" ? "创建成功" : "修改成功";
          if (this.editID != "") this.addFrom.id = this.editID;
          api.PolicyEdit(this.addFrom).then(res => {
            this.isask = false;
            this.loading = false;
            if (res.code == 0) {
              this.$message.success(createText);
              this.$emit('AddOk');
            } else {
              processErrors(res);
            }
          });
        } else {
          return false;
        }
      });
    }
  },
}
</script>
<style lang='scss' scoped>
.demo-drawer__content { height: calc(100% - 80px); overflow-y: auto; margin-top: 20px; overflow-x: hidden; }
.demo-drawer__footer { position: absolute; bottom: 0; left: 0; width: 100%; padding: 10px; text-align: center; }
.demo-drawer__footer .el-button { margin: 0 10px; width: calc(50% - 20px); }
</style>
